import { Skeleton } from '@/components/ui/skeleton'

/**
 * Skeleton a tutto schermo dell'app-shell, mostrato mentre l'AuthenticatedLayout
 * risolve i fetch iniziali (current user, permessi, stato abbonamento). Evita
 * lo sfondo grigio senza feedback alla prima apertura. Approssima la struttura
 * caricata (sidebar + header + dashboard) così la transizione è morbida.
 */
export function AppShellSkeleton() {
  return (
    <div className="flex h-svh w-full overflow-hidden bg-background" aria-busy="true" aria-label="Caricamento">
      {/* Sidebar */}
      <aside className="hidden w-64 shrink-0 flex-col gap-2 border-r bg-card p-3 md:flex">
        <div className="mb-2 flex items-center gap-2 px-2 py-1.5">
          <Skeleton className="h-7 w-7 rounded-md" />
          <Skeleton className="h-5 w-24" />
        </div>
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-full rounded-md" />
        ))}
        <div className="mt-auto flex items-center gap-2 px-1 py-2">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-4 w-28" />
        </div>
      </aside>

      {/* Main */}
      <div className="flex min-w-0 flex-1 flex-col">
        {/* Header */}
        <header className="flex h-14 items-center justify-between border-b bg-card px-4">
          <Skeleton className="h-5 w-40" />
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-24 rounded-md" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </header>

        {/* Content (dashboard-like) */}
        <main className="flex-1 overflow-auto p-6">
          <Skeleton className="mb-6 h-7 w-48" />
          <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-xl border bg-card p-5">
                <Skeleton className="mb-3 h-4 w-24" />
                <Skeleton className="mb-2 h-8 w-16" />
                <Skeleton className="h-3 w-20" />
              </div>
            ))}
          </div>
          <div className="rounded-xl border bg-card p-5">
            <Skeleton className="mb-4 h-5 w-36" />
            <Skeleton className="h-56 w-full" />
          </div>
        </main>
      </div>
    </div>
  )
}
